import { useState } from "react";
import { useModal } from "../contexts";
import { Source } from "../interfaces";
import Modal from "./Modal";
import TextInputField from "./TextInputField";

interface Props {
  source: Source;
  updateBlock: (name: any) => void;
}

function WorkflowModalWebhookNameChange({ source, updateBlock }: Props) {
  const { closeModal } = useModal();

  const [name, setName] = useState<string>(source.webhookConfig!.name);

  return (
    <Modal>
      <div className="flex flex-col gap-4 w-[400px]">
        <div className="font-gilroy font-bold">Update Webhook Source Name</div>
        <TextInputField label="Webhook Source Name" value={name} onChange={name => setName(name)} />
        <div className="flex justify-between">
          <button className="font-semibold text-sm" onClick={() => closeModal()} type="button">Canel</button>
          <button className="btn btn-blue" onClick={() => { updateBlock(name); closeModal(); }}>Update</button>
        </div>
      </div>
    </Modal>
  )
}

export default WorkflowModalWebhookNameChange;
